import { Box, Typography, Stack, Button } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import Page from '../components/page/page'
import emptyState from '../../assets/imgs/empty-state.png'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Page title={`${t('commons.page_not_found')}`} headerBack>
      <Box sx={{ boxSizing: 'border-box', display: 'flex', justifyContent: 'start', width: '100%', m: { xs: 1, sm: 1, md: 0 }, ml: { xs: 1, sm: 1, md: 1, lg: 6, xl: 0 } }}>
        <Box sx={{ width: '100%', maxWidth: '1232px' }}>
          <Stack width={'100%'} height="100%" alignItems="center" spacing={1}>
            <img src={emptyState} width="200px" />
            <Typography variant="titleLarge">{t('commons.page_not_found')}</Typography>
            <Typography variant="body">{t('commons.page_not_found_help')}</Typography>
            <Box py={2}>
              <Button variant="outlined" onClick={() => navigate('/')}>
                {t('commons.go_to_dashboard')}
              </Button>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Page>
  )
}
export default NotFoundPage
